import { render, staticRenderFns } from "./GlobalRoleBindings.vue?vue&type=template&id=c1b43f3e&scoped=true&"
import script from "./GlobalRoleBindings.vue?vue&type=script&lang=js&"
export * from "./GlobalRoleBindings.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRoleBindings.vue?vue&type=style&index=0&id=c1b43f3e&prod&lang=scss&"
import style1 from "./GlobalRoleBindings.vue?vue&type=style&index=1&id=c1b43f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b43f3e",
  null
  
)

export default component.exports